import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63a69f02"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 환급에 대해 궁금하신가요? ")
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "button" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cover" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 세무사, 회계사가 알려드립니다. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 사업자라면 누구나 환급대상인데 모르고 계시는 분이 많은 거 같아요. 더낸세금을 많이 알려서 한 분이라도 더 환급 받을 수 있도록 도와드리고 싶어요. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 김현정 세무사 | 송지섭 회계사 ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc-shadow" }, null, -1))

import { ref, onMounted } from 'vue'

import Text from '@/components/common/TextComponent.vue'
import VideoPlayButton from '@/styles/icon/VideoPlayButton.vue'
import { COLOR_SET } from '@/styles/variables'
import { getImageUrl } from '@/utils/getImageUrl'

import { setAnimationObserver } from '../libs/observer'
import VideoPlayer from './VideoPlayer.vue'



export default /*#__PURE__*/_defineComponent({
  name: 'LandingExpert',
  setup(__props) {

const showVideoPlayer = ref(false)
const isHoverTarget = ref(false)
const wrapper = ref()
const showAnimation = ref(false)

const handleHoverIn = () => {
  isHoverTarget.value = true
}

const handleHoverOut = () => {
  isHoverTarget.value = false
}

const handlePlayVideo = () => {
  showVideoPlayer.value = true
}

onMounted(() => {
  setAnimationObserver(wrapper.value, () => { showAnimation.value = true }, 0.2)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showVideoPlayer.value)
      ? (_openBlock(), _createBlock(VideoPlayer, {
          key: 0,
          "target-url": "https://www.youtube.com/embed/TFqTlMRq0mg",
          onClose_modal: _cache[0] || (_cache[0] = ($event: any) => (showVideoPlayer.value = false))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "wrapper",
      ref: wrapper,
      class: "wrapper"
    }, [
      _createVNode(Text, {
        size: "64px",
        "line-height": "1.25",
        "mobile-size": "30px",
        "mobile-width": "300px",
        weight: "700",
        "word-break": "keep-all",
        "text-align": "center",
        class: _normalizeClass(["animation-show title-text", { show: showAnimation.value }])
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", {
        class: _normalizeClass(["video-wrapper animation-show", { show: showAnimation.value }]),
        onMouseover: handleHoverIn,
        onMouseout: handleHoverOut,
        onClick: handlePlayVideo
      }, [
        _createElementVNode("img", {
          src: _unref(getImageUrl)('landing/video8.png')
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(VideoPlayButton, {
            "mobile-size": 60,
            opacity: isHoverTarget.value ? '1' : '0.7'
          }, null, 8, ["opacity"])
        ]),
        _hoisted_4
      ], 34),
      _createElementVNode("div", {
        class: _normalizeClass(["desc animation-show", { show: showAnimation.value }])
      }, [
        _createVNode(Text, {
          size: "32px",
          weight: "700",
          color: _unref(COLOR_SET).blue01,
          "mobile-size": "18px"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["color"]),
        _createVNode(Text, {
          size: "24px",
          margin: "8px 0 60px 0",
          "mobile-margin": "0px 0px 30px 0",
          "mobile-size": "16px"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(Text, {
          size: "24px",
          weight: "700",
          "text-align": "right",
          "mobile-size": "12px"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ], 2),
      _hoisted_8
    ], 512)
  ], 64))
}
}

})